/* Collection swatches preview photos and carry the clicked finish into product links. */
(function (window, document) {
  'use strict';
  function snapshot(image) {
    var result = {};
    ['src', 'srcset', 'alt', 'width', 'height'].forEach(function (name) { result[name] = image.getAttribute(name); });
    return result;
  }
  function photoFor(button) {
    var src = button.getAttribute('data-wo-card-photo-src');
    if (!src || !/^(https?:)?\/\//i.test(src)) { return null; }
    return {
      src: src, srcset: button.getAttribute('data-wo-card-photo-srcset'),
      alt: button.getAttribute('data-wo-card-photo-alt'),
      width: button.getAttribute('data-wo-card-photo-width'),
      height: button.getAttribute('data-wo-card-photo-height')
    };
  }
  function paint(image, photo) {
    ['srcset', 'src', 'alt', 'width', 'height'].forEach(function (name) {
      if (photo[name] === null || photo[name] === undefined || photo[name] === '') { image.removeAttribute(name); }
      else { image.setAttribute(name, photo[name]); }
    });
  }
  function finishDestination(href, optionName, value, location) {
    if (!window.URL || !optionName || !value) { return href; }
    if (!/(finish|colou?r)/i.test(optionName)) { return href; }
    try {
      var url = new window.URL(href, location.href);
      if (url.origin !== location.origin) { return href; }
      url.searchParams.delete('variant');
      url.searchParams.set('wo_finish_option', optionName);
      url.searchParams.set('wo_finish', value);
      var page = new window.URL(location.href);
      var preview = page.searchParams.get('preview_theme_id');
      if (preview && /^\d+$/.test(preview)) { url.searchParams.set('preview_theme_id', preview); }
      return url.pathname + url.search + url.hash;
    } catch (error) { return href; }
  }
  function init(card) {
    if (card.getAttribute('data-wo-photo-ready') === 'true') { return; }
    var image = card.querySelector('.wo-card-image');
    var buttons = card.querySelectorAll('button[data-wo-card-swatch]');
    if (!image || !buttons.length) { return; }
    var original = snapshot(image);
    var links = Array.prototype.map.call(card.querySelectorAll('[data-wo-card-product-link]'), function (link) {
      return { element: link, href: link.getAttribute('href') };
    });
    var selected = null;
    function restore() { paint(image, selected ? photoFor(selected) : original); }
    for (var i = 0; i < buttons.length; i++) {
      (function (button) {
        var photo = photoFor(button);
        if (!photo) { button.disabled = true; return; }
        function preview() { if (!button.disabled) { paint(image, photo); } }
        button.addEventListener('mouseenter', preview);
        button.addEventListener('mouseleave', restore);
        button.addEventListener('focus', preview);
        button.addEventListener('blur', restore);
        button.addEventListener('click', function (event) {
          event.preventDefault();
          event.stopPropagation();
          if (button.disabled) { return; }
          selected = button;
          links.forEach(function (link) {
            link.element.setAttribute('href', finishDestination(link.href, button.getAttribute('data-wo-card-finish-option'), button.getAttribute('data-wo-card-finish-value'), window.location));
          });
          for (var b = 0; b < buttons.length; b++) { buttons[b].setAttribute('aria-pressed', String(buttons[b] === selected)); }
          preview();
        });
      })(buttons[i]);
    }
    card.setAttribute('data-wo-photo-ready', 'true');
  }
  function boot() {
    var cards = document.querySelectorAll('.wo-product-card');
    for (var i = 0; i < cards.length; i++) { init(cards[i]); }
  }
  window.WheelsOutletCardSwatches = { init: init, photoFor: photoFor, finishDestination: finishDestination };
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', boot); } else { boot(); }
  document.addEventListener('shopify:section:load', boot);
})(window, document);
